/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Birthday_Event_Ended_DescriptionInputs */

const en_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baking has come to an end, but there's still time to visit the Exchange Shop, open until July 3, 02:00 (UTC+0).`)
};

const ar_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهى وقت الخبز، ولكن لا يزال هناك وقت لزيارة متجر الاستبدال، المفتوح حتى 3 يوليو، الساعة 02:00 (UTC+0).`)
};

const de_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Backen ist beendet, aber es bleibt noch Zeit, den Einlöse-Shop zu besuchen, der bis zum 3. Juli um 02:00 Uhr (UTC+0) geöffnet ist.`)
};

const es_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El horneado ha llegado a su fin, pero aún estás a tiempo de visitar la Tienda de intercambio, abierta hasta el 3 de julio a las 02:00 (UTC+0).`)
};

const fr_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cuisson est terminée, mais il est encore temps de visiter la Boutique d'échange, ouverte jusqu'au 3 juillet à 02:00 (UTC+0).`)
};

const it_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La cottura è giunta al termine, ma c'è ancora tempo per visitare il Negozio di Scambio, aperto fino al 3 luglio alle 02:00 (UTC+0).`)
};

const ja_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベーキングは終了しましたが、7月3日 02:00 (UTC+0) まで開いている交換ショップを訪れる時間はまだあります。`)
};

const ko_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`베이킹은 끝났지만, 7월 3일 02:00(UTC+0)까지 운영되는 교환 상점을 방문할 시간은 아직 남아있어요.`)
};

const pt_br_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fornada chegou ao fim, mas ainda dá tempo de visitar a Loja de Trocas, que fica aberta até 3 de julho, às 02:00 (UTC+0).`)
};

const ru_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпечка подошла к концу, но у вас еще есть время заглянуть в Магазин обмена, который открыт до 3 июля, 02:00 (UTC+0).`)
};

const th_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การอบเสร็จสิ้นลงแล้ว แต่คุณยังมีเวลาไปที่ร้านค้าแลกเปลี่ยน ซึ่งเปิดให้บริการจนถึงวันที่ 3 กรกฎาคม เวลา 02:00 น. (UTC+0)`)
};

const tr_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pişirme sona erdi, ancak 3 Temmuz 02:00'ye (UTC+0) kadar açık olan Takas Mağazası'nı ziyaret etmek için hâlâ vaktiniz var.`)
};

const zh_cn_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙活动已经结束，不过兑换商店会持续开放至 7 月 3 日 02:00（UTC+0），不要错过哦！`)
};

const zh_tw_birthday_event_ended_description = /** @type {(inputs: Birthday_Event_Ended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`烘焙活動已經結束，不過印花兌換商店會持續開放至 7 月 3 日 02:00（UTC+0），不要錯過囉！`)
};

/**
* | output |
* | --- |
* | "Baking has come to an end, but there's still time to visit the Exchange Shop, open until July 3, 02:00 (UTC+0)." |
*
* @param {Birthday_Event_Ended_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const birthday_event_ended_description = /** @type {((inputs?: Birthday_Event_Ended_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Birthday_Event_Ended_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_birthday_event_ended_description(inputs)
	if (locale === "ar") return ar_birthday_event_ended_description(inputs)
	if (locale === "de") return de_birthday_event_ended_description(inputs)
	if (locale === "es") return es_birthday_event_ended_description(inputs)
	if (locale === "fr") return fr_birthday_event_ended_description(inputs)
	if (locale === "it") return it_birthday_event_ended_description(inputs)
	if (locale === "ja") return ja_birthday_event_ended_description(inputs)
	if (locale === "ko") return ko_birthday_event_ended_description(inputs)
	if (locale === "pt_br") return pt_br_birthday_event_ended_description(inputs)
	if (locale === "ru") return ru_birthday_event_ended_description(inputs)
	if (locale === "th") return th_birthday_event_ended_description(inputs)
	if (locale === "tr") return tr_birthday_event_ended_description(inputs)
	if (locale === "zh_cn") return zh_cn_birthday_event_ended_description(inputs)
	return zh_tw_birthday_event_ended_description(inputs)
});